// extracted by mini-css-extract-plugin
module.exports = {"category":"X_dX","wrapp":"X_dY","category__wrapper":"X_dZ"};